import React from "react";
import DAAModuleSubtopic from "../DAAModuleSubtopic";

const DAA_AssemblyLineScheduling = () => (
  <DAAModuleSubtopic
    title="Dynamic Programming – Assembly Line Scheduling"
    videos={[
      "https://www.youtube.com/embed/EqGpcClPkkw",
      "https://www.youtube.com/embed/8I0kiyxfrM0",
      "https://www.youtube.com/embed/tEU19olSqsU",
      "https://www.youtube.com/embed/NODQhmJyMYE"
    ]}
    takeaways={[
      { text: "Goal: Minimize total time to go through all stations from start to end, choosing the optimal line at each stage." },
      { text: "Each step depends on the best previous step, and overlapping subproblems are used in decision making." },
      { text: "Time Complexity: O(n)" },
      { text: "Space Complexity: O(n), can be optimized to O(1) using two variables per line." },
      { text: "Applications include manufacturing, industrial automation, and multi-path optimization problems." }
    ]}
    questions={[
      {
        text: "A car factory has two assembly lines with entry and exit costs, station costs, and transfer costs between lines. Calculate the fastest time to get through the factory and trace the path a car should take for fastest production.",
        image: "/ALS.png"
      },
      {
        text: "Given n stations on two assembly lines with specific processing and transfer times, implement a dynamic programming solution to compute the minimum total time."
      },
      {
        text: "Explain the recurrence relation used in Assembly Line Scheduling and show its application for a 5-station example."
      },
      {
        text: "Modify the algorithm to work with 3 or more assembly lines and discuss the changes needed in the dynamic programming approach."
      }
    ]}
    exampleVideos={[
      
    ]}
  />
);

export default DAA_AssemblyLineScheduling ;
